import { Component, OnInit, Input, Output, ElementRef, EventEmitter, ViewEncapsulation, ViewChild, SimpleChanges, AfterViewChecked, OnChanges, OnDestroy } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { AssistanceTicket } from '../../../../models/assistanceticket';
import { AssistanceService } from '../../../../models/assistanceservice';
import { AssistanceCategory } from '../../../../models/assistance-category';
import { AssistanceProvider } from '../../../../models/assistance-provider';
import { Country } from '../../../../models/country';
import { ConfService } from '../../../../services/conf.service';
import { ApiService } from '../../../../api/api.service';
import { SelectLocationComponent } from '../../../select-location/select-location.component';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { AssistanceTicketsTypesService } from '../assistance-tickets-types.service';
import { IamService } from '../../../../services/iam.service';
import { MessageService } from 'primeng/api';
import { State } from '../../../../models/state';
import { debounceTime, map, startWith, Subscription } from 'rxjs';
import { AssistancePriceSvc } from '../../../assistances/services/assistance-price.service';
import moment from 'moment';
import { AssitanceCaseProvider } from '../../../../models/assistance-case-provider';
import { LoaderService } from 'src/app/api/loader.service';
import { AssistanceTicketSvc } from '../../services/assistance-ticket.service';
import { child, ref, set } from 'firebase/database';
import { FirebaseService } from 'src/app/services/firebase.service';
import { FormControl } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { FormulaService } from 'src/app/services/formula.service';
import { DynamicFieldsService } from 'src/app/services/dynamic-fields.service';


declare var google: any;

@Component({
    selector: 'app-assistance-tickets-step',
    templateUrl: './assistance-tickets-step.component.html',
    styleUrls: ['./assistance-tickets-step.component.css'],
    encapsulation: ViewEncapsulation.None,
    providers: [AssistancePriceSvc, MessageService],
    standalone: false
})
export class AssistanceTicketsStepComponent implements OnInit, AfterViewChecked, OnChanges, OnDestroy {
  @Input() grouptickets: any[] = [];
  @Input() servicegroup: any;
  @Input() showstep: boolean;
  @Input() totalCount: number;
  @Input() id_service: number;
  @Input() categories: any[] = [];
  @Input() countries: any[] = [];
  @Input() assistancecase;
  @Input() sale_canceled;
  @Input() caseLocation: any = {};
  @Input() sds_provider: boolean = false;
  @Input() by_connection: boolean = false;
  @Input() sinister_plan_service: boolean = false;
  @Input() assistance_plan_service: any;
  @Input() buca_plan_service: boolean = false;
  @Input() copago: boolean = false;
  @Input() pago_copago: number;
  @Input() disabled: EventEmitter<boolean>;
  @Input() disableallstep: EventEmitter<void>;
  @Output() update = new EventEmitter<AssistanceTicket>();
  @Output() cancelEvent = new EventEmitter();
  @Output() activeIndexReady: EventEmitter<number>;
  @Output() setUserProvider = new EventEmitter<boolean>();
  @Output() quotationComment = new EventEmitter<any>();
  states: any[];
  statesDistrict: any[];
  state_id: number = null;
  country_id: number = 0;
  state_district_id: number = null;
  is_visible = true;
  is_confirmation_visible = false;
  page = 1
  hasMoreProviders = true
  isLoading = false
  maxScroll = 1
  //cartas
  @Input() titular_name: any;
  @Input() tel: any;
  @Input() tipo_servicio: any;
  @Input() usuario_asesor: any;

  showSeeMoreProviders = false;

  providersMap;
  ticket_service;

  editOutNetworkProvider: any = {};

  providerLocation = new EventEmitter<any>();
  mapcenter = new EventEmitter<any>();
  country_code: any = {
    country_name: '',
    country_local: '',
  };
  MedicalCategories = [
    3, 16, 17, 18, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33,
  ];
  editcategory: AssistanceCategory;
  editservice: AssistanceService;
  editprovider: AssitanceCaseProvider; // AssistanceProvider;
  showProviderDialog = false;
  showProviderUserDialog = false;
  provider_id = new EventEmitter<number>();
  case_service_id = new EventEmitter<number>();
  providers_app = new EventEmitter<any>();
  provider_app = new EventEmitter<any>();
  case_id = new EventEmitter<number>();
  is_case_normal = new EventEmitter<boolean>();
  service_id: number;
  hasUsers = false;
  html = '';
  emails = '';
  programtime: any;
  images = [];
  items: MenuItem[];
  providers: any[] = [];
  siteUsers: any[] = [];
  appUsers: any[] = [];
  providersAll: any[] = [];
  selectCountry: Country;
  selectedProviders: any[] = [];
  selectedProvidersAll: any[] = [];
  @Input() readonly = false;
  stepnumber: any;
  activeIndex = 0;
  comment = '';
  timeestimated;
  number_provider = '';
  email_provider = '';
  providertemp = '';
  namepatient = '';
  identificationnumber = '';
  description = '';
  coordinatedby = '';
  daynhour = '';
  branch = '';
  responsible = '';
  cost_ = '';
  activateemail = false;
  observation = '';
  showNewDialog = false;
  cases_ids = '';

  assistanceSaleCar: any;

  types: any[] = [];
  editticket: AssistanceTicket;
  selectedRow: number;
  newticket = false;
  setClickedRow: Function;
  isCalcRoadDistance = false;
  countryState: State = null;
  indexArray: any[] = [];
  fromlatitude: any;
  fromlongitude: any;
  tolatitudes: any[] = [];
  tolongitudes: any[] = [];
  latitude: any;
  longitude: any;
  iAm = null;
  cartas = false;
  fieldsRequired = {
    provider: false,
  };
  programmed = 0;
  connection = 0;
  isDisabled = false;
  subscription: Subscription;
  filter: any = {
    id: null,
  };
  mapOptions: any = {};
  mapOverlays: any = {};
  expand_more: boolean = false;
  idProviderSelected: number = null;
  isAppCase: boolean = false;
  isNormalCase: boolean = false;

  new_provider_id = null;
  appointmentDate: any;
  searchProvider: string;
  subCategory: string;
  address: string = null;
  agente: string = '';
  sendletter: boolean = true;

  answers: any;
  answers_text: any;

  @Input() flagAssignProvider: boolean = false;
  @Output() notifyAssignProviderView = new EventEmitter<boolean>();
  @ViewChild(SelectLocationComponent) locationComponent;

  catalog_provider_cancellation_reasons = [];
  id_provider_cancellation_reason = '';

  globalTimeZone = new Date();
  hourTimeZone = 0;


  @Input() inlatitude: any;
  @Input() inlongitude: any;
  //---validar latitude longitud
  have_coordinates = true;
  msgs: any[] = [];
  db: any
  applyLinkService: boolean = false;

  polygonFilter: boolean = false;

  private providerPolygons: Map<number, google.maps.Polygon[]> = new Map();
  private currentHoveredProviderId: number | null = null;
  provider_formula_coverage_id: number = 0;
  providerSelectedIsDangerZone: boolean = false;

  // Propiedades para el sistema de fórmulas
  showFormulaModal: boolean = false;
  selectedFormula: any = null;
  formulaResult: any = null;
  additionalExpenses: number = 0;
  additionalExpensesComment: string = '';

  // Propiedades para el modal de fórmulas
  availableFormulas: any[] = [];
  dynamicFields: any[] = [];
  fieldValues: { [fieldId: string]: any } = {};
  formulaLoading: boolean = false;
  formulaError: string = '';

  // Map routing helpers
  private currentDirectionsRenderer: any = null;
  private currentRoutePolyline: any = null;
  private currentInfoWindow: any = null;

  isNewConfigActive: boolean = false;

  constructor(
    public el: ElementRef,
    public conf: ConfService,
    private api: ApiService,
    private translate: TranslateService,
    private typesService: AssistanceTicketsTypesService,
    private iam: IamService,
    private assistancePriceSvc: AssistancePriceSvc,
    private messageService: MessageService,
    private loaderService: LoaderService,
    public ticketSvc: AssistanceTicketSvc,
    private firebaseService: FirebaseService,
    private formulaService: FormulaService,
    private dynamicFieldsService: DynamicFieldsService

  ) {
    this.iAm = this.iam.isRole;
    this.subscription = this.typesService.getServiceID().subscribe((data) => {
      if (data.serviceid === this.editticket.service_id) {
        this.showstep = true;
        this.service_id = data.serviceid;
      }
    });
    this.activeIndexReady = new EventEmitter();
    this.hourTimeZone = (this.globalTimeZone.getTimezoneOffset() / 60) * -1;
  }

  ngOnInit() {
    this.db = this.firebaseService.db;

    this.setCoordinates(this.inlatitude, this.inlongitude)
    this.api.extra
      .getAssistanceSaleCar(this.assistancecase.id)
      .promise()
      .then((assSaleCar) => {
        this.assistanceSaleCar = assSaleCar;
      })
      .catch((e) => { });

    this.getAnswers(this.assistancecase.id);

    this.country_id = this.assistancecase.origin_country_id
      ? this.assistancecase.origin_country_id
      : this.assistancecase.country_id;
    this.mapOptions = {
      center: {
        lat: 14.590518806702539,
        lng: -90.51070153590592,
      },
      zoom: 13,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_TOP,
      },
    };

    if (this.disabled) {
      this.disabled.subscribe((disabled) => {
        this.setCoordinates(this.inlatitude, this.inlongitude)
        this.isDisabled = disabled;
      });
    }

    this.types = this.typesService.getTypes();
    this.items = [
      {
        label: this.types[0].label,
        command: (event: any) => {
          this.activeIndex = 0;
        },
      },
      {
        label: this.types[1].label,
        command: (event: any) => {
          this.activeIndex = 1;
        },
      },
      {
        label: this.types[2].label,
        command: (event: any) => {
          this.activeIndex = 2;
        },
      },
      {
        label: this.types[3].label,
        command: (event: any) => {
          this.activeIndex = 3;
        },
      },
      {
        label: 'Close Ticket',
        command: (event: any) => {
          this.activeIndex = 4;
        },
      },
    ];

    this.translateTypes();

    this.setClickedRow = function (index, provider) {
      this.selectedRow = index;
      this.selectProvider(provider);
    };

    this.editticket = new AssistanceTicket();
    this.grouptickets = this.grouptickets.filter(
      (t) =>
        t.ticket_type !== 12 &&
        t.ticket_type !== 22 &&
        t.ticket_type !== 6 &&
        t.ticket_type !== 7 &&
        t.ticket_type !== this.ticketSvc.CANCELED_SERVICE_BY_REIMBURSEMENT &&
        t.ticket_type !== 8 &&
        t.ticket_type !== 9 &&
        t.ticket_type !== 10 &&
        t.ticket_type !== 11 &&
        t.ticket_type !== 14 && // exception
        t.ticket_type !== 15 && // exception
        t.ticket_type !== 16 && // notify to customer
        t.ticket_type !== 17 && // assign / unassign user
        t.ticket_type !== 18 &&
        t.ticket_type !== 19 &&
        t.ticket_type !== 35 &&
        t.ticket_type !== 50 &&
        t.ticket_type !== 30 &&
        t.ticket_type !== 60 &&
        t.ticket_type !== 36
    );
    this.ticket_service = this.grouptickets.filter(
      (t) => t.ticket_type == 1
    )[0];

    if (this.totalCount > 0) {
      this.editticket = Object.assign({}, this.grouptickets[0]);
    }

    this.editcategory = new AssistanceCategory();
    this.editservice = new AssistanceService();
    this.editprovider = new AssitanceCaseProvider();
    this.editticket.programmed = null;
    this.isCalcRoadDistance = false;
    this.countryState = null;

    if (this.sale_canceled) this.connection = 1;
    if (this.disableallstep) {
      this.disableallstep.subscribe((d) => {
        this.items.forEach((item) => {
          item.disabled = true;
        });
      });
    }
    this.getCountries();
    this.onSelectCountry(this.country_id);
    this.init();

    this.getCatalogCancellation('cancellation_reason_providers');

    this.api.getAssitanceProviderFlag.get().promise().then(response => {
      this.isNewConfigActive = response?.is_active;
    }).catch(err => {
      console.error(err);
    });
  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes['inlatitude']) {
      this.setCoordinates(changes['inlatitude'].currentValue, changes['inlongitude'].currentValue)
    }

  }

  setCoordinates(latitude, longitud) {

    if (latitude != undefined && longitud != null && longitud != 0) {
      this.have_coordinates = true;
      this.msgs = [
        { severity: 'success', summary: '', detail: 'Geolocalización recibida' }
      ];



    } else {
      this.have_coordinates = false;

      this.msgs = [
        { severity: 'error', summary: '', detail: 'El caso no tiene ubicación' }
      ];
    }


    this.caseLocation = {
      latitude: latitude,
      longitude: longitud,
    };

  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getCountries() {
    this.api.countries
      .get()
      .promise()
      .then((resp) => {
        this.countries = resp.data;
      });
  }

  ngAfterViewChecked() {
    this.resetStepLine();
  }

  resetStepLine() {
    this.stepnumber =
      this.el.nativeElement.getElementsByClassName('ui-steps-number');
    const stepline =
      this.el.nativeElement.getElementsByClassName('ui-steps-item');
    let loop_temp: number;
    let loop = 0;
    loop_temp = this.editticket.ticket_type;
    switch (loop_temp) {
      case 5: {
        loop = 5;
        break;
      }
      case 7: {
        loop = 1;
        break;
      }
      case 6: {
        loop = 1;
        break;
      }
      case 8: {
        loop = 1;
        break;
      }
      default: {
        loop = loop_temp;
        break;
      }
    }

    for (let i = 0; i < loop; i++) {
      if (this.stepnumber.item(i)) {
        this.stepnumber.item(i).innerHTML = '<i class="fa fa-check">';
        stepline.item(i).classList.remove('ui-state-default');
        stepline.item(i).classList.add('ui-state-highlight');

        if (loop_temp === 5) {
          this.stepnumber.item(i).style.backgroundColor = '#5CB85C';
          stepline.item(i).style.opacity = '1';
          stepline.item(i).style.background = '#5CB85C';
        }
      }
    }
  }


  restartProviders() {
    this.providers = []
    this.appUsers = []
    this.page = 1
    this.providerCtrl.setValue('')
    this.init()
  }

  async init(): Promise<void> {
    this.selectCountry = _.cloneDeep(this.assistancecase.country);
    if (this.sale_canceled) this.connection = 1;
    this.items.forEach((item) => {
      item.disabled = true;
    });

    if (this.editticket.ticket_type) {
      if (
        this.editticket.ticket_type === 4 ||
        this.editticket.ticket_type === 5
      ) {
        if (this.editticket.ticket_type === 4) {
          this.activeIndex = 4;
        } else {
          this.activeIndex = -1;
        }
        this.activeIndexReady.emit(this.activeIndex);
        return;
      } else if (this.editticket.ticket_type === 3) {
        this.items[3].disabled = false;
        this.activeIndex = 3;
      } else if (this.editticket.ticket_type === 2) {
        if (this.editticket.provider_status === 2) {
          this.editticket.provider_status = 1;
          this.editticket.provider_id = null;
          this.editticket.provider_site_id = null;
          this.editticket.coverage_id = null;
          this.items[1].disabled = false;
          this.activeIndex = 1;
        } else {
          this.items[2].disabled = false;
          this.activeIndex = 2;
        }
      } else {
        // 6,7,8,1
        this.editticket.provider_id = null;
        this.editticket.provider_site_id = null;
        this.editticket.coverage_id = null;
        this.editticket.latitude = null;
        this.editticket.longitude = null;
        this.items[1].disabled = false;
        this.activeIndex = 1;
      }
    }

    this.activeIndexReady.emit(this.activeIndex);

    if (this.editticket.service) {
      this.editservice = this.editticket.service;
      this.editcategory = this.editticket.service.category;
      this.countryState = this.assistancecase.countryState;

      if (this.editticket.provider_id) {
        this.editprovider = new AssitanceCaseProvider();
        this.editprovider.provider_id = this.editticket.provider_id;
        this.editprovider.provider_site_id = this.editticket.provider_site_id;
        this.editprovider.coverage_id = this.editticket.coverage_id;
        this.editprovider.case_id = this.editticket.case_id;
        this.editprovider.provider = this.editticket.provider;
        this.editprovider.provider_site = this.editticket.provider_site;
        this.editprovider.coverage = this.editticket.coverage;

        if (this.editprovider.provider.price instanceof Number) {
          this.setProviderprice(
            this.editprovider.provider,
            this.editprovider.provider_site_id,
            this.editprovider.coverage_id,
            this.editticket.service_id
          );
        }
      } else {
        this.api.assistanceProvicerSites.getList(this.country_id, this.ticket_service.service_id, this.ticket_service.case_id)
          .promise()
          .then((ProvidersList) => {
            this.providerList = ProvidersList.data
            this.filteredProviders = ProvidersList.data;
          })
        this.providerCtrl.valueChanges
          .pipe(
            debounceTime(300),
            startWith(''),
            map(value => this.filterProviders(value))
          )
          .subscribe(filtered => {
            this.filteredProviders = filtered;
          });
        this.loaderService.display(true);

        const [case_providers, providers_app] = await Promise.all([
          this.api.assistanceProvicerSites
            .v2get(this.country_id, this.id_service)
            .page(this.page)
            .filter({ lat: this.caseLocation.latitude, lng: this.caseLocation.longitude, polygon_filter: this.polygonFilter })
            .promise(),
          this.api.assistanceProvicerSites
            .getApp(
              this.country_id,
              this.id_service,
              this.assistancecase.id
            )
            .promise()
        ]);

        this.setProvidersFromResponse(case_providers, providers_app);
      }
    }
  }

  onSetVehicleType($event) {
    if ($event == '1') {
      this.editticket.car_size = 1;
    } else if ($event == '2') {
      this.editticket.car_size = 2;
    } else if ($event == '3') {
      this.editticket.car_size = 3;
    } else {
    }
  }

  setMap(event) {
    this.providersMap = event.map;

    setTimeout(() => {
      let bounds = new google.maps.LatLngBounds();
      this.mapOverlays.forEach((marker) => {
        bounds.extend(marker.getPosition());
      });

      setTimeout(() => {
        this.providersMap.fitBounds(bounds);
      }, 1000);
    }, 1000);
  }


  setProvidersFromResponse(providers, providers_app) {
    this.providers = Array.isArray(providers.data)
      ? JSON.parse(JSON.stringify(providers.data))
      : [];

    let appProviders = Array.isArray(providers_app.data)
      ? JSON.parse(JSON.stringify(providers_app.data))
      : [];

    this.maxScroll = providers.total / environment.providerListAmount

    this.selectedProviders = this.providers;
    if (appProviders.length > 0) {
      this.isAppCase = true;
      this.isNormalCase = providers_app.normal_case;
      this.providers = this.providers.map((provider) => {
        let finded = appProviders.find(
          (pr) => pr.provider_id == provider.provider_id
        );
        if (finded) {
          provider.users = finded.users;
        }
        return provider;
      });
      this.appUsers = appProviders;
    }

    this.mapOverlays = [];

    this.mapOverlays.push(
      new google.maps.Marker({
        position: {
          lat: this.caseLocation.latitude,
          lng: this.caseLocation.longitude,
        },
        title: 'Ubicacion cliente',
        icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/location_provider22.png',
      })
    );

    let provider_site_already_in_map = [];
    this.selectedProviders.forEach((provider) => {
      if (
        provider.provider_site &&
        provider.provider_site.latitude &&
        provider.provider_site.longitude
      ) {
        if (
          provider_site_already_in_map.indexOf(provider.provider_site.id) == -1
        ) {
          this.mapOverlays.push(
            new google.maps.Marker({
              position: {
                lat: provider.provider_site.latitude,
                lng: provider.provider_site.longitude,
              },
              title: provider.provider_site.name,
              icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/location_client22.png',
            })
          );

          provider_site_already_in_map.push(provider.provider_site.id);
        }
      }
    });

    let indexofprovider = 0;
    this.indexArray = [];
    this.tolongitudes = [];
    this.tolatitudes = [];
    this.loaderService.display(false);
    let providers_coverage = {}
    this.selectedProviders.forEach((p: AssitanceCaseProvider) => {
      if (providers_coverage[p.provider.id]) {
        providers_coverage[p.provider.id].push({
          "site_id": p.provider_site_id ? p.provider_site_id : null,
          "coverage_id": p.coverage_id ? p.coverage_id : null,
          "timezone": p.provider.timezone ? p.provider.timezone : null,
          "price": p.provider.price ? p.provider.price : null,
          "provider": p.provider
        })
      }
      else {
        providers_coverage[p.provider.id] = []
        providers_coverage[p.provider.id].push({
          "site_id": p.provider_site_id ? p.provider_site_id : null,
          "coverage_id": p.coverage_id ? p.coverage_id : null,
          "timezone": p.provider.timezone ? p.provider.timezone : null,
          "price": p.provider.price ? p.provider.price : null,
          "provider": p.provider
        });
      }

      indexofprovider++;
    });
    this.setGroupPrice(providers_coverage)
    this.isLoading = false

  }

  setProvidersFromResponseall(providers) {
    this.providersAll = JSON.parse(JSON.stringify(providers.data));
    this.providersAll = this.providersAll.sort((a, b) => {
      const nameA = a.provider.name.toLowerCase();
      const nameB = b.provider.name.toLowerCase();
      if (nameA < nameB) return -1;
      if (nameA > nameB) return 1;
      return 0;
    });

    this.selectedProvidersAll = this.providersAll;
    let indexofprovider = 0;
    this.providersAll.forEach((p: AssitanceCaseProvider) => {
      this.setProviderprice(
        p.provider,
        p.provider_site_id,
        p.coverage_id,
        this.editticket.service_id
      );
      indexofprovider++;
    });

    this.loaderService.display(false);
  }

  async setProviderprice(
    provider: AssistanceProvider,
    provider_site_id,
    coverage_id,
    service_id
  ): Promise<void> {
    try {
      const editprice = await this.api.assistancePricesProvidersByIdservicesById
        .get(provider.id, provider_site_id, coverage_id, service_id)
        .promise();
      const offset = provider.timezone;
      const now = new Date();
      const utcDate = new Date(now.getTime() + now.getTimezoneOffset() * 60000);
      provider.price = this.assistancePriceSvc.calculateBasePrice(
        editprice,
        utcDate,
        false,
        offset
      );
    } catch (error) { }
  }

  async indexChange(index): Promise<void> {
    this.items.forEach((item) => {
      item.disabled = true;
    });
    this.items[index].disabled = false;
    this.activeIndex = index;
    await this.init();
    this.showstep = true;
  }

  closeticket(ticket) {
    this.editticket = Object.assign({}, ticket);
    this.editticket.id = null;
    this.editticket.comment = null;
    this.items.forEach((item) => {
      item.disabled = true;
    });
    this.editticket.ticket_type = 5;
    this.update.emit(this.editticket);
    return;
  }

  showProviderCard(t_provider_id) {
    this.provider_id.emit(t_provider_id);
    this.case_service_id.emit(this.service_id);
    this.showProviderDialog = true;
  }

  hideProviderCard() {
    this.showProviderDialog = false;
    this.provider_id.emit(null);
    this.case_service_id.emit(null);
  }

  selectProvider(provider, all = false) {
    if (all) {
      this.editprovider = _.find(
        this.providersAll,
        (p) => p.id === provider.id
      );
    } else {
      this.editprovider = _.find(this.providers, (p) => p.id === provider.id);
    }
    this.editticket.provider_id = provider.provider_id;
    this.editticket.provider_site_id = provider.provider_site_id;
    this.editticket.coverage_id = provider.coverage_id;
    this.editticket.provider_status = 1;
    this.editticket.provider = provider

    if (provider.assistancePrice_id) {
      this.editticket.assistancePrice_id = provider.assistancePrice_id;
      this.editticket.stateName = provider.state;
      this.editticket.cityName = provider.city;
    } else {
      this.editticket.assistancePrice_id = null;
      this.editticket.stateName = null;
      this.editticket.cityName = null;
    }

    if (provider.network == 1) {
      this.branch = provider.name
      this.address = provider.provider_site ? provider.provider_site?.address : ""
    }


    this.providers.forEach((p) => {
      p.select = false;
    });
    provider.select = true;
    this.fieldsRequired['provider'] = false;






    setTimeout(() => {
      if (this.editprovider.lat && this.editprovider.lng) {
        const location = {
          latitude: this.editprovider.lat,
          longitude: this.editprovider.lng,
        };
        this.providerLocation.emit(location);
      }
    }, 500);
  }

  onSetSiteUsers(site) {
    this.appointmentDate = null;
    this.new_provider_id = null;
    this.comment = null;
    if (this.editticket.provider_id) {
      this.loaderService.display(true);
      this.api.provider_site_users
        .get(site.id)
        .promise()
        .then((users) => {
          this.siteUsers = users.sort((a, b) => {
            const nameA = a.name.toLowerCase();
            const nameB = b.name.toLowerCase();
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
          });
          this.loaderService.display(false);
        });
    }
  }

  getCatalogCancellation(catalog) {
    this.loaderService.display(true);

    this.api.typologies
      .get()
      .params({ catalog })
      .promise()
      .then((resp) => {
        this.catalog_provider_cancellation_reasons = resp.data[0].typologies;
        this.loaderService.display(false);
      })
      .catch((e) => {
        this.loaderService.display(false);
      });
  }

  onSelectProviderCancellationReason(id) {
    this.editticket.provider_cancellation_reason = parseInt(id, 10);
  }

  onSubmit() {
    const firebaseData = {
      case_id: this.assistancecase.id,
      provider_id: this.editticket.provider_id
    }
    this.setTickettype(this.editticket);

    if (
      this.editticket.provider_status == 2 &&
      this.editticket.provider_cancellation_reason != null
    ) {
      let pcr = this.catalog_provider_cancellation_reasons.find(
        (x) => x.value_ == this.editticket.provider_cancellation_reason
      ).description;
      this.editticket.comment =
        'Motivo de rechazo: ' + pcr + '.\n' + this.comment;
    } else {
      this.editticket.comment = this.comment;
    }

    // this.editticket.comment = this.comment;
    this.editticket.assistance_provider_user_id = this.new_provider_id;
    this.editticket.sub_category_provider = this.subCategory;
    this.editticket.provider_address = this.address;

    this.daynhour = (this.appointmentDate || new Date()).toString()
    this.editticket.programdate = (this.appointmentDate || new Date());
    this.editticket.appointment_date = (this.appointmentDate || null);
    if (this.appointmentDate) this.assistancecase.appointment_date = this.appointmentDate;

    if (
      this.editticket.ticket_type == 2 &&
      this.editticket.provider_status == 1
    ) {
      if (!this.editticket.comment) {
        alert('Comentario es requerido');
        return;
      }
      if (!this.editticket.programdate) {
        this.messageService.add({
          severity: 'error',
          summary: 'Resultado',
          detail: 'Fecha de cita es requerida',
        });
        return;
      }
      if (this.sds_provider && this.buca_plan_service) {
        if (!this.editticket.assistance_provider_user_id) {
          this.messageService.add({
            severity: 'error',
            summary: 'Resultado',
            detail: 'Odontólogo requerido',
          });
          return;
        }
        if (!this.editticket.programdate) {
          this.messageService.add({
            severity: 'error',
            summary: 'Resultado',
            detail: 'Fecha de cita es requerida',
          });
          return;
        }
        if (!this.editticket.sub_category_provider) {
          this.messageService.add({
            severity: 'error',
            summary: 'Resultado',
            detail: 'Sub Categoria es requerida',
          });
          return;
        }
        if (!this.editticket.provider_address) {
          this.messageService.add({
            severity: 'error',
            summary: 'Resultado',
            detail: 'Dirección del proveedor es requerida',
          });
          return;
        }
      }
    }

    if (
      this.editticket.ticket_type == 2 &&
      this.editticket.provider_status == 2
    ) {
      if (!this.editticket.comment) {
        alert('Comentario es requerido');
        return;
      }
      if (this.sds_provider && this.buca_plan_service) {
        if (!this.editticket.assistance_provider_user_id) {
          this.messageService.add({
            severity: 'error',
            summary: 'Resultado',
            detail: 'Odontólogo requerido',
          });
          return;
        }
        if (!this.editticket.programdate) {
          this.messageService.add({
            severity: 'error',
            summary: 'Resultado',
            detail: 'Fecha de cita es requerida',
          });
          return;
        }
        if (!this.editticket.sub_category_provider) {
          this.messageService.add({
            severity: 'error',
            summary: 'Resultado',
            detail: 'Sub Categoria es requerida',
          });
          return;
        }
        if (!this.editticket.provider_address) {
          this.messageService.add({
            severity: 'error',
            summary: 'Resultado',
            detail: 'Dirección del proveedor es requerida',
          });
          return;
        }
      }
    }

    if (this.editticket.timeestimated > 0) {
      this.editticket.comment = `${this.editticket.comment} // tiempo estimado: ${this.editticket.timeestimated} minutos"`;
    }

    if (this.editticket.number_provider) {
      this.editticket.comment = `${this.editticket.comment}, a numero de proveedor: ${this.editticket.number_provider}`;
    }

    if (this.editticket.provider_status === 3 && this.activeIndex == 1) {
      this.editticket.comment = this.editOutNetworkProvider.comment
        ? this.editOutNetworkProvider.comment
        : null;
    }

    this.editticket.send_letter = this.sendletter

    if (this.newticket === true) {
      if (
        this.editticket.programmed &&
        this.fieldsRequired['programdate'] === true
      )
        return;
      this.newticket = false;
      this.editticket.latitude = this.latitude;
      this.editticket.longitude = this.longitude;
      this.isDisabled = true;
      this.update.emit(this.editticket);
      return;
    }

    if (
      !_.isNumber(this.editticket.provider_id) &&
      this.activeIndex === 1 &&
      !(
        this.editticket.ticket_type === 6 ||
        this.editticket.ticket_type === 7 ||
        this.editticket.ticket_type ===
        this.ticketSvc.CANCELED_SERVICE_BY_REIMBURSEMENT ||
        this.editticket.ticket_type === 2
      )
    ) {
      if (this.editticket.provider_status === 3) {
        this.fieldsRequired['provider'] = false;
      } else {
        this.fieldsRequired['provider'] = true;
      }

      this.showstep = true;
    } else {
      // set default provider ticket position
      if (
        this.editticket.ticket_type === 2 &&
        (this.editticket.latitude === null ||
          this.editticket.longitude === null)
      ) {
        if (this.editprovider.lat && this.editprovider.lng) {
          this.editticket.latitude = this.editprovider.lat;
          this.editticket.longitude = this.editprovider.lng;
        } else if (this.caseLocation) {
          this.editticket.latitude = this.caseLocation.latitude;
          this.editticket.longitude = this.caseLocation.longitude;
        }
      }
      if (this.editticket.ticket_type === 4) {
        this.validateCaseLinkService(this.assistancecase.id).then(isLinkValid => {
          if (isLinkValid) {
            this.updateCaseStatus(this.assistancecase.id.toString(), 2)

          } else {
          }
        });
        // this.updateCaseStatus(this.assistancecase.id.toString(), 3)

      }
      if (this.editticket.ticket_type === 5) {
        this.validateCaseLinkService(this.assistancecase.id).then(isLinkValid => {
          if (isLinkValid) {
            this.updateCaseStatus(this.assistancecase.id.toString(), 3)


          } else {
          }
        });
      }
      this.showstep = false;
      this.newticket = false;
      this.isDisabled = true;

      this.update.emit(this.editticket)
      if (this.activeIndex == 1) {
        if (this.editticket.provider.network_type == 1 && this.sendletter && this.servicegroup?.service.auto_sendletter_type == 1 && this.editticket.provider_status == 1) {
          this.Generarcarta()
        }
        this.validateCaseLinkService(this.assistancecase.id).then(isLinkValid => {
          if (isLinkValid) {
            this.statusAssignProvider(firebaseData, false);
          } else {
          }
        });

        this.goToBack();
      }
    }

  }

  setTickettype(editticket) {
    if (this.activeIndex === 0) editticket.ticket_type = 1;
    else if (this.activeIndex === 1) editticket.ticket_type = 2;
    else if (this.activeIndex === 2) editticket.ticket_type = 3;
    else if (this.activeIndex === 3) editticket.ticket_type = 4;
  }

  translateTypes() {
    const labels = this.typesService.getTypeLabels(this.types);

    if (labels.length === 0) {
      return;
    }
    // Translate all labels
    this.translate.get(labels).subscribe((trans: string[]) => {
      for (let i = 0; i < labels.length; i++) {
        const label = labels[i];

        if (this.types[i].label) {
          this.types[i].label = trans[label];
        }
      }

      this.updateItems();
    });
  }

  updateItems() {
    if (this.items.length >= 4) {
      this.items[0].label = this.types[0].label;
      this.items[1].label = this.types[1].label;
      this.items[2].label = this.types[2].label;
      this.items[3].label = this.types[3].label;

      // Update the missing item that is not in types
      this.translate.get(this.items[4].label).subscribe((res: string) => {
        this.items[4].label = res;
      });
    }
  }

  getContactPhones(contactPhones) {
    if (contactPhones == null) {
      return [];
    }

    return contactPhones.split(',');
  }

  step1SetLocation(location) {
    this.editticket.latitude = location.latitude;
    this.editticket.longitude = location.longitude;
  }

  step1SelectMap() {
    if (this.editprovider.lat && this.editprovider.lng) {
      const location = {
        latitude: this.editprovider.lat,
        longitude: this.editprovider.lng,
      };
      setTimeout(() => {
        this.providerLocation.emit(location);
      }, 500);
    }
  }

  hideProviderUsers() {
    this.is_visible = true;
    this.is_confirmation_visible = false;
    this.showProviderUserDialog = false;
  }

  showProviderUsers(users, provider) {
    this.providers_app.emit(users);
    this.provider_app.emit(provider);
    this.case_id.emit(this.assistancecase.id);
    this.is_case_normal.emit(this.isNormalCase);
    this.is_visible = true;
    this.is_confirmation_visible = false;
    this.showProviderUserDialog = true;
  }

  onCancel() {
    this.showstep = false;
  }

  onSelectedUserProvider(isDone) {
    this.hideProviderUsers();
    if (isDone == true) {
      this.setUserProvider.emit(true);
    }
  }

  closeConfirm(close) {
    this.is_visible = close;
    this.is_confirmation_visible = !close;
  }

  formcartaau() {
    this.cartas = true;
  }

  async getAnswers(assistance_case_id) {
    this.api.assistanceSaleAnswers
      .get(assistance_case_id)
      .promise()
      .then((response) => {
        this.answers = response;
        this.answers_text = this.answers
          .map(item => `${item.question_text}: ${item.answer_text}`)
          .join(' ');
      })
      .catch((e) => {
        this.loaderService.display(false);
      });
  }

  Generarcarta() {
    this.activateemail = true;
    const regex_namepatient = /Nombre del paciente:\s+([a-zA-ZÁÉÍÓÚÑáéíóúñ ]+)/;

    const match = this.answers_text.match(regex_namepatient);
    this.namepatient = match ? match[1].trim() : '';
    this.responsible = this.servicegroup?.service.auto_sendletter_type == 2 ? 'Afiliado paga el 100%' : 'Salud Primero'

    const regex_idpatient = /ID del Paciente(?:\s*\(.*?\))?:\s*([a-zA-Z0-9]+)/i;
    const match_id = this.answers_text.match(regex_idpatient);
    this.identificationnumber = match_id ? match_id[1].trim() : 'N/A'

    let appointment_date = new Date((this.appointmentDate || new Date()).toISOString())
    appointment_date.setHours(appointment_date.getHours() + this.hourTimeZone);
    let date = appointment_date.toISOString().split('T')
    let daynhour = date[0] + ' ' + date[1].slice(0, 8)
    this.daynhour = daynhour
    const filter = Object.assign({}, this.filter);
    filter['case_id'] = this.cases_ids ? this.assistancecase.id.toString() + ',' + this.cases_ids : this.assistancecase.id.toString();
    filter['nombre_titular'] = this.titular_name;
    filter['telefono'] = this.tel;
    filter['namepatient'] = this.namepatient;
    filter['identificationnumber'] = this.identificationnumber;
    filter['description'] = this.description;
    filter['coordinatedby'] = this.coordinatedby;
    filter['daynhour'] = this.daynhour;
    filter['branch'] = this.branch;
    filter['responsible'] = this.responsible;
    filter['cost'] = this.cost_;
    filter['observation'] = this.comment;
    filter['usuario_asesor'] = this.usuario_asesor;
    filter['tipo_servicio'] = this.tipo_servicio;

    filter['subcategory'] = this.subCategory;
    filter['agente'] = this.agente;
    filter['direccion'] = this.address;
    filter['opcion'] = this.copago ? '3' : this.servicegroup?.service.auto_sendletter_type;



    this.api.assistancecases
      .createletter()
      .filter(filter)
      .promise()
      .then((users) => {
        this.filter = filter
        this.Enviarcartaprov()
      })
      .catch((e) => {
        let apiError = '';

        try {
          let err = JSON.parse(e._body);
          apiError = err.error;
        } catch (e) {
          apiError = '';
        }

        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: `${e.error} ${apiError}`,
        });
      });
  }

  Enviarcartaprov() {
    this.cartas = true;
    const regex_mail = /Correo Electronico:\s*([\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,6})/;
    const match = this.servicegroup.comment.match(regex_mail);
    this.emails += match ? (',' + match[1].trim()) : '';

    if (this.assistancecase?.email) {
      this.emails += ',' + this.assistancecase.email
    }

    if (this.assistancecase?.member?.email) {
      this.emails += ',' + this.assistancecase.member.email
    }

    this.filter['correos'] = this.emails;

    this.api.assistancecases
      .sendletteremail()
      .filter(this.filter)
      .promise()
      .then((users) => {
        this.messageService.add({
          severity: 'info',
          summary: 'Info',
          detail: 'Carta Enviada',
        });
      })
      .catch((e) => {
        let apiError = '';

        try {
          let err = JSON.parse(e._body);
          apiError = err.error;
        } catch (e) {
          apiError = '';
        }

        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: `${e.error} ${apiError}`,
        });
      });
  }
  enviarcartaclie() { }

  onSelectday(date) {
    if (date === null) {
      this.fieldsRequired['programdate'] = true;
    } else {
      const set_date = date + ' ' + this.programtime;
      this.editticket.programdate = moment(set_date).toDate();
      this.fieldsRequired['programdate'] = false;
    }
  }

  test(provider) { }

  onSelectProvider(provider, all = false) {
    this.providerSelectedIsDangerZone = provider.is_danger_zone;
    let idProviderSelected = provider.id;
    if (this.idProviderSelected == idProviderSelected) {
      this.idProviderSelected = null;
      this.editticket.provider_id = null;
      this.editticket.provider_site_id = null;
      this.editticket.coverage_id = null;
      this.editticket.provider_status = null;
      this.editticket.assistancePrice_id = null;
      this.editticket.cityName = null;
      this.editticket.stateName = null;
    } else {
      this.idProviderSelected = idProviderSelected;
      this.selectProvider(provider, all);
      this.address = provider.provider_site.address
        ? provider.provider_site.address
        : provider.provider.address;
      if (this.servicegroup?.service.service_type == 1) {
        this.address = this.servicegroup?.address_destination;
      } else if (this.servicegroup?.service.service_type == 2) {
        this.address = 'N/A'
      }
      this.branch = provider.name
      this.cost_ = this.pago_copago ? this.pago_copago.toString() : ''
      this.subCategory = this.servicegroup?.service.name;
      this.emails = provider.provider_site.cabin_emails
        ? provider.provider_site.cabin_emails.replace(';', ',')
        : '';
      this.onSetSiteUsers(provider.provider_site);
    }

    if (provider && this.caseLocation) {
      console.log("Dibujando ruta para provider:", provider);
      this.drawProviderToCaseRoute(provider);
    }
  }

  showModalOutOfNetworkProvider() {
    this.editOutNetworkProvider = {};
    this.showNewDialog = true;
  }

  onSubmitOutOfNetworkProvider() {
    this.showNewDialog = false;

    let comment = '';
    this.editticket.provider_status = 3;

    if (this.editOutNetworkProvider.comment) {
      comment = this.editOutNetworkProvider.comment;
      this.editOutNetworkProvider.comment = '';
    }

    if (this.editOutNetworkProvider.name) {
      this.editOutNetworkProvider.comment +=
        'nombre: ' + this.editOutNetworkProvider.name + ' ';
    }
    if (this.editOutNetworkProvider.phone) {
      this.editOutNetworkProvider.comment +=
        'Teléfono: ' + this.editOutNetworkProvider.phone + ' ';
    }
    if (this.editOutNetworkProvider.service) {
      this.editOutNetworkProvider.comment +=
        'Servicio: ' + this.editOutNetworkProvider.service + ' ';
    }
    if (this.editOutNetworkProvider.cost) {
      this.editOutNetworkProvider.comment +=
        'Costo: ' + this.editOutNetworkProvider.cost + ' ';
    }
    if (this.editOutNetworkProvider.headquartersAddress) {
      this.editOutNetworkProvider.comment +=
        'Dirección Sede: ' +
        this.editOutNetworkProvider.headquartersAddress +
        ' ';
    }

    if (comment) {
      this.editOutNetworkProvider.comment += 'Comentario: ' + comment;
    }

    this.onSubmit();
  }

  onSelectAssignProvider() {
    this.flagAssignProvider = true;
    this.notifyAssignProviderView.emit(true);
  }

  goToBack() {
    this.flagAssignProvider = false;
    this.notifyAssignProviderView.emit(false);
  }

  openLinkLocationCustomer() {
    let url = `https://www.google.com/maps/place/${this.caseLocation.latitude},${this.caseLocation.longitude}`;
    this.api.copyToClipboard(url);
    this.messageService.add({
      severity: 'info',
      summary: 'Info',
      detail: 'Link de la localización del cliente copiado al portapapeles.',
    });
  }

  copyText(text) {
    this.api.copyToClipboard(text);
    this.messageService.add({
      severity: 'info',
      summary: 'Info',
      detail: 'Teléfono del cliente copiado al portapapeles.',
    });
  }

  seeMoreProvider() {
    this.showSeeMoreProviders = true;
  }

  getProviders() {
    this.loaderService.display(true);
    const filter = {};
    if (this.state_id) filter['state_id'] = this.state_id;
    if (this.state_district_id) filter['district_id'] = this.state_district_id;
    if (this.searchProvider) filter['provider'] = this.searchProvider;
    this.api.assistanceProvicerSites
      .get(this.country_id, this.id_service)
      .filter(filter)
      .promise()
      .then((caseProviders) => {
        if (caseProviders.count == 0) {
          this.translate.get('No providers found').subscribe((res: string) => {
            this.messageService.add({
              severity: 'info',
              summary: 'Info',
              detail: res,
            });
          });
        }
        this.setProvidersFromResponseall(caseProviders);
      })
      .catch((e) => {
        this.loaderService.display(false);
        this.translate
          .get('An error occurred while getting providers')
          .subscribe((res: string) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: res,
            });
          });
      });
  }

  onSelectState(state_id) {
    if (state_id) {
      const filter = { state_id: state_id };
      this.api.statedistricts
        .get()
        .filter(filter)
        .promise()
        .then((d) => {
          this.statesDistrict = d.data;
        });
    } else {
      this.statesDistrict = [];
    }
  }

  onSelectCountry(country_id) {
    if (country_id) {
      this.api.states
        .get(country_id)
        .promise()
        .then((states) => {
          this.states = states;
        });
    } else if (country_id == 0) {
      this.state_id = null;
      this.state_district_id = null;
    }
  }
  validateCaseLinkService(caseId): Promise<boolean> {
    let payload = {
      case_id: caseId
    }

    return this.api.assistancecases
      .validateLinkService(payload)
      .promise()
      .then((response) => {
        this.applyLinkService = response['link_service_active']
        return this.applyLinkService;
      })
      .catch((e) => {
        return this.applyLinkService;
      })
  }
  async statusAssignProvider(data, isReasign) {

    const dbRefAssistanceCases = ref(this.db, 'asistance_cases');
    const childAssistanceCasesClient = child(dbRefAssistanceCases, data.case_id.toString());
    set(childAssistanceCasesClient, {
      'provider': data.provider_id,
      'status': 1,
    },);
    const childAssistanceCasesProvider = child(dbRefAssistanceCases, data.provider_id.toString());
    set(childAssistanceCasesProvider, {
      'provider': data.provider_id,
      'status': 1,
    },);
    // if (isReasign) {
    //   const childAssistanceCasesLastProvider = child(dbRefAssistanceCases, this.last_provider_id.toString());
    //   set(childAssistanceCasesLastProvider, {
    //     'provider': this.last_provider_id,
    //     'status': 0,
    //   },);
    // }
  }
  async updateCaseStatus(caseId: string, status: number) {
    const dbRefAssistanceCases = ref(this.db, 'asistance_cases');
    const childAssistanceCase = child(dbRefAssistanceCases, caseId.toString());

    await set(childAssistanceCase, {
      'status': status
    });
  }


  loadMoreProviders() {
    this.hasMoreProviders = false
    if (this.page > Math.ceil(this.maxScroll)) {
      this.hasMoreProviders = false
      this.isLoading = false
      return
    }
    this.isLoading = true
    this.page++
    const filter = {};
    if (this.state_id) filter['state_id'] = this.state_id;
    if (this.state_district_id) filter['district_id'] = this.state_district_id;
    if (this.searchProvider) filter['provider'] = this.searchProvider;



    Promise.all([
      this.api.assistanceProvicerSites
        .v2get(this.country_id, this.ticket_service.service_id)
        .page(this.page)
        .filter({ lat: this.caseLocation.latitude, lng: this.caseLocation.longitude, polygon_filter: this.polygonFilter })
        .promise(),
      this.api.assistanceProvicerSites
        .getApp(
          this.country_id,
          this.ticket_service.service_id,
          this.assistancecase.id
        )
        .promise()
    ]).then(([case_providers, providers_app]) => {
      this.addProvidersFromResponse(case_providers, providers_app);
    }).catch(error => {
      console.error('Error loading more providers:', error);
      this.hasMoreProviders = false;
      this.isLoading = false;
    });

  }



  /**
  *
  * @param providers is now from provider site model
  */
  addProvidersFromResponse(providers, providers_app) {

    const newProviders = JSON.parse(JSON.stringify(providers.data));

    const newAppProviders = JSON.parse(JSON.stringify(providers_app.data));



    // Agregar nuevos proveedores a la lista existente
    this.providers = [...this.providers, ...newProviders];
    this.selectedProviders = [...this.selectedProviders, ...newProviders];

    if (newAppProviders.length > 0) {
      this.isAppCase = true;
      this.isNormalCase = providers_app.normal_case;

      this.providers = this.providers.map((provider) => {
        let found = newAppProviders.find(
          (pr) => pr.provider_id == provider.provider_id

        );
        if (found) {
          provider.users = found.users;
        }
        return provider;
      });
      // Agregar los nuevos app users (puedes ajustar lógica si no quieres duplicados)
      this.appUsers = [...(this.appUsers || []), ...newAppProviders];
    }

    // Marcadores del mapa
    let provider_site_already_in_map = this.providers.map(p => p.provider_site?.id).filter(id => !!id);

    newProviders.forEach((provider) => {
      if (
        provider.provider_site &&
        provider.provider_site.latitude &&
        provider.provider_site.longitude &&
        provider_site_already_in_map.indexOf(provider.provider_site.id) == -1
      ) {
        this.mapOverlays.push(
          new google.maps.Marker({
            position: {
              lat: provider.provider_site.latitude,
              lng: provider.provider_site.longitude,
            },
            title: provider.provider_site.name,
            icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/location_client22.png',
          })
        );
        provider_site_already_in_map.push(provider.provider_site.id);
      }
    });

    // Agregar ubicación del cliente si aún no está (solo la primera vez idealmente)
    if (this.mapOverlays.length === 0 || !this.mapOverlays.some(m => m.title === 'Ubicacion cliente')) {
      this.mapOverlays.push(
        new google.maps.Marker({
          position: {
            lat: this.caseLocation.latitude,
            lng: this.caseLocation.longitude,
          },
          title: 'Ubicacion cliente',
          icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/location_provider22.png',
        })
      );
    }

    // Actualizar info de precios por proveedor
    const providers_coverage = {};
    this.selectedProviders.forEach((p: AssitanceCaseProvider) => {

      if (!providers_coverage[p.provider.id]) {
        providers_coverage[p.provider.id] = [];
      }
      providers_coverage[p.provider.id].push({
        site_id: p.provider_site_id ?? null,
        coverage_id: p.coverage_id ?? null,
        timezone: p.provider.timezone ?? null,
        price: p.provider.price ?? null,
        provider: p.provider
      });
    });
    this.setGroupPrice(providers_coverage);

    // Aplicar zoom ideal después de agregar nuevos marcadores
    this.applyMapBounds();
  }

  async setGroupPrice(providers): Promise<void> {
    try {
      let editprice
      this.api.assistancePricesProviders
        .post(providers, this.editticket.service_id)
        .promise().then((response: any) => {
          editprice = response

          for (let providerKey in editprice) {
            if (editprice.hasOwnProperty(providerKey)) {
              const provider = editprice[providerKey];
              const offset = provider.timezone;
              const now = new Date();
              const utcDate = new Date(now.getTime() + now.getTimezoneOffset() * 60000);
              for (let [index, Provider] of this.providers.entries()) {
                if (Provider['provider_id'] == provider['provider_id']) {
                  this.providers[index].provider.price = this.assistancePriceSvc.calculateBasePrice(
                    provider,
                    utcDate,
                    false,
                    offset
                  );
                }
              }
            }
          }
        }
        )

    } catch (error) {
    }
    this.hasMoreProviders = true
    this.isLoading = false
  }

  providerCtrl = new FormControl('');
  providerList: any[] = [];
  filteredProviders: any;

  normalizeText(text: string): string {
    return (text || '')
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]/g, '')
  }
  normalizePhoneArray(phones: string[] | undefined): string[] {
    if (!phones || !Array.isArray(phones)) return [];
    return phones.map(phone => this.normalizeText(phone));
  }



  filterProviders(value: string | any): any[] {
    const rawText = typeof value === 'string' ? value : value?.name || '';
    const normalizedInput = this.normalizeText(rawText);

    return this.providerList.filter(provider => {
      const fieldsToSearch = [
        this.normalizeText(provider.name || ''),
        this.normalizeText(provider.sap_code || ''),
        ...this.normalizePhoneArray(provider.phones_cabin),
        ...this.normalizePhoneArray(provider.phones_accounting),
        ...this.normalizePhoneArray(provider.phones_web),
        ...this.normalizePhoneArray(provider.contact_phones),
        this.normalizeText(provider.site_name || ''),
        ...this.normalizePhoneArray(provider.site_cabin_phones),
      ];

      return fieldsToSearch.some(field => field.includes(normalizedInput));
    });
  }



  onProviderSelected(selected: any) {
    if (!selected || !selected.id) return;

    this.providers = [];
    this.appUsers = [];
    this.isLoading = true;

    const providerId = selected.id;
    const isApp = selected.isApp || false;
    const serviceId = this.ticket_service?.service_id || 0;
    const countryId = this.country_id || 0;
    const caseId = this.ticket_service?.case_id || 0;

    this.api.assistanceProvicerSites
      .getFullProviderInfo(providerId, isApp, serviceId, countryId, caseId)
      .promise()
      .then(data => {
        this.setProvidersFromResponse(data, []);
        this.isLoading = false;
      });

  }


  displayFn(provider: any): string {
    if (!provider) return '';
    return `${provider.name || ''}`.trim();
  }

  resetProviderSelected() {
    this.idProviderSelected = null;
    this.editticket.provider_id = null;
    this.editticket.provider_site_id = null;
    this.editticket.coverage_id = null;
    this.editticket.provider_status = null;
    this.editticket.assistancePrice_id = null;
    this.editticket.cityName = null;
    this.editticket.stateName = null;
  }

  async activatePolygonFilter() {
    this.polygonFilter = !this.polygonFilter;
    this.resetProviderSelected();

    this.page = 1;
    this.loaderService.display(true);
    let case_providers = await this.api.assistanceProvicerSites
      .v2get(this.country_id, this.id_service)
      .page(this.page)
      .filter({ lat: this.caseLocation.latitude, lng: this.caseLocation.longitude, polygon_filter: this.polygonFilter })
      .promise();
    let providers_app = await this.api.assistanceProvicerSites
      .getApp(
        this.country_id,
        this.id_service,
        this.assistancecase.id
      )
      .promise();
    this.loaderService.display(false);
    this.setProvidersFromResponse(case_providers, providers_app);

    // Aplicar zoom ideal después de cargar los nuevos datos
    this.applyMapBounds();
  }


  onProviderHover(provider: any) {
    if (!provider || !provider.provider_polygons || provider.provider_polygons.length === 0) {
      return;
    }

    this.clearProviderPolygons();

    this.drawProviderPolygons(provider);
    this.currentHoveredProviderId = provider.id;
  }

  onProviderHoverOut(provider: any) {
    if (!provider || this.currentHoveredProviderId !== provider.id) {
      return;
    }

    this.clearProviderPolygons();
    this.currentHoveredProviderId = null;
  }

  private drawProviderPolygons(provider: any): void {
    if (!provider.provider_polygons || !Array.isArray(provider.provider_polygons)) {
      return;
    }

    if (!this.providersMap) {
      console.warn('Mapa no disponible para dibujar polígonos');
      return;
    }

    const polygons: google.maps.Polygon[] = [];

    provider.provider_polygons.forEach((polygonData: any) => {
      try {
        const coordinates = JSON.parse(polygonData.polygon_coordinates);

        if (!Array.isArray(coordinates) || coordinates.length < 3) {
          console.warn('Polígono inválido:', polygonData);
          return;
        }

        const polygon = new google.maps.Polygon({
          paths: coordinates,
          fillColor: polygonData.color || '#FF5722',
          fillOpacity: (polygonData.fill_opacity || 50) / 100,
          strokeColor: polygonData.color || '#FF5722',
          strokeWeight: polygonData.stroke_weight || 2,
          strokeOpacity: 0.8,
          map: this.providersMap // Usar la referencia correcta al mapa
        });

        polygons.push(polygon);

      } catch (error) {
        console.error('Error al dibujar polígono:', error, polygonData);
      }
    });

    this.providerPolygons.set(provider.id, polygons);
  }

  private clearProviderPolygons(): void {
    this.providerPolygons.forEach((polygons, providerId) => {
      polygons.forEach(polygon => {
        polygon.setMap(null);
      });
    });
    this.providerPolygons.clear();
  }

  openFormulaModal(provider_coverage_id: number) {
    this.provider_formula_coverage_id = provider_coverage_id;
    this.showFormulaModal = true;

    // Cargar fórmulas disponibles
    this.loadAvailableFormulas();
  }

  closeFormulaModal() {
    this.showFormulaModal = false;
    this.selectedFormula = null;
    this.formulaResult = null;
    this.availableFormulas = [];
    this.dynamicFields = [];
    this.fieldValues = {};
    this.formulaLoading = false;
    this.formulaError = '';
  }

  onFormulaSelected(event: any) {
    this.selectedFormula = event.formula;
    this.formulaResult = event.result;

    // Actualizar el comentario con la información de la fórmula
    this.updateCommentWithFormula();
  }

  // Métodos para el modal de fórmulas con p-dialog
  async loadAvailableFormulas() {
    this.formulaLoading = true;
    this.formulaError = '';

    try {
      console.log('Cargando fórmulas para:', {
        provider_coverage_id: this.provider_formula_coverage_id,
        service_id: this.service_id
      });

      // Usar el nuevo CRUD para obtener fórmulas
      const formulas = await this.formulaService.getFormulas(this.provider_formula_coverage_id, this.service_id);
      console.log('Fórmulas obtenidas:', formulas);

      // Filtrar solo las fórmulas activas
      this.availableFormulas = formulas.filter(f => f.isActive);
      console.log('Fórmulas activas:', this.availableFormulas);

      // Cargar campos dinámicos
      await this.loadDynamicFields();

      // Si hay exactamente una fórmula, seleccionarla automáticamente
      if (this.availableFormulas.length === 1) {
        console.log('Seleccionando automáticamente la única fórmula disponible:', this.availableFormulas[0]);
        this.selectedFormula = this.availableFormulas[0];
      }

    } catch (error) {
      console.error('Error al cargar las fórmulas:', error);
      this.formulaError = 'Error al cargar las fórmulas disponibles';
      this.availableFormulas = [];
    } finally {
      this.formulaLoading = false;
    }
  }

  async loadDynamicFields() {
    try {
      console.log('Cargando campos dinámicos para service_id:', this.service_id);
      const fields = await this.dynamicFieldsService.getFieldsForService(this.service_id);
      console.log('Campos dinámicos obtenidos:', fields);

      this.dynamicFields = fields;
      // Inicializar valores desde backend
      await this.initializeFieldValues();

    } catch (error) {
      console.error('Error al cargar campos dinámicos:', error);
      this.dynamicFields = [];
    }
  }

  async initializeFieldValues() {
    if (!this.service_id || !this.provider_formula_coverage_id) {
      this.fieldValues = {};
      return;
    }

    await this.dynamicFieldsService.getFieldValues(this.service_id, this.provider_formula_coverage_id)
      .then(fieldValuesResponse => {
        // Convertir la respuesta del backend al formato esperado por el frontend
        const newFieldValues: { [fieldId: string]: any } = {};

        fieldValuesResponse.forEach((fieldValue: any) => {
          if (fieldValue.field_id && fieldValue.field_value !== undefined) {
            newFieldValues[fieldValue.field_id.toString()] = fieldValue.field_value;
          }
        });

        this.fieldValues = { ...this.fieldValues, ...newFieldValues };

        // Después de cargar valores del backend, calcular campos booleanos automáticos
        this.calculateAutomaticBooleanFields();
      })
      .catch(error => {
        console.error('Error loading field values from API:', error);
        // En caso de error, mantener los valores actuales y calcular campos automáticos
        this.calculateAutomaticBooleanFields();
      });
  }

  private getCurrentDateInCountryTimezone(): Date {
    if (!this.selectCountry || this.selectCountry.timezone === undefined || this.selectCountry.timezone === null) {
      console.warn('No hay información de timezone del país, usando UTC');
      return new Date();
    }

    // Obtener la fecha actual en UTC
    const now = new Date();

    const timezoneOffsetMinutes = this.selectCountry.timezone * 60;

    const countryDate = new Date(now.getTime() + (timezoneOffsetMinutes * 60 * 1000));

    return countryDate;
  }

  private async calculateAutomaticBooleanFields() {
    // Obtener la fecha y hora en la zona horaria del país del assistance case
    const currentDate = this.getCurrentDateInCountryTimezone();
    const currentTime = currentDate.getUTCHours() * 60 + currentDate.getUTCMinutes();

    // 1. Calcular es_feriado
    await this.calculateEsFeriado(currentDate);

    // 2. Calcular es_fin_de_semana
    this.calculateEsFinDeSemana(currentDate);

    // 3. Calcular es_de_noche
    this.calculateEsDeNoche(currentTime);

    // 4. Calcular es_danger_zone
    this.calculateEsDangerZone();
  }

  private async calculateEsFeriado(currentDate: Date) {
    try {
      if (!this.country_id) {
        console.log('No hay country_id disponible para verificar feriados');
        return;
      }

      // Obtener feriados del país
      const holidays = await this.api.catalogEquivalence.getHolidays().promise();
      console.log('Feriados obtenidos:', holidays);

      // Filtrar feriados del país actual
      const countryHolidays = holidays.filter((holiday: any) =>
        holiday.value_ === this.country_id.toString()
      );

      console.log('Feriados del país actual:', countryHolidays);

      // Formatear fecha actual como MM-DD
      const currentMonthDay = `${String(currentDate.getUTCMonth() + 1).padStart(2, '0')}-${String(currentDate.getUTCDate()).padStart(2, '0')}`;
      console.log('Fecha actual (MM-DD):', currentMonthDay);

      // Verificar si la fecha actual coincide con algún feriado
      const isHoliday = countryHolidays.some((holiday: any) => {
        console.log('Comparando feriado:', {
          from_: holiday.from_,
          to_: holiday.to_,
          currentMonthDay: currentMonthDay
        });

        // Construir fecha del feriado en formato MM-DD
        // Si from_ y to_ son DD y MM respectivamente, construir MM-DD
        let holidayDate = '';
        if (holiday.from_ && holiday.to_) {
          // Asumir que from_ es día y to_ es mes
          holidayDate = `${String(holiday.to_).padStart(2, '0')}-${String(holiday.from_).padStart(2, '0')}`;
        } else if (holiday.from_ && holiday.from_.includes('-')) {
          // Si ya está en formato MM-DD
          holidayDate = holiday.from_;
        }

        console.log('Fecha del feriado construida:', holidayDate);

        // Comparar fechas
        const matches = holidayDate === currentMonthDay;

        console.log('¿Coincide?', {
          holidayDate,
          currentMonthDay,
          matches
        });

        return matches;
      });

      // Debug: Mostrar todos los campos dinámicos disponibles
      console.log('Campos dinámicos disponibles:', this.dynamicFields.map(f => ({
        id: f.id,
        field_name: f.field_name,
        normalized: this.normalizeFieldName(f.field_name)
      })));

      // Buscar el campo es_feriado y actualizar su valor
      const esFeriadoField = this.dynamicFields.find(field =>
        field.name === 'Es feriado'
      );

      if (esFeriadoField) {
        this.fieldValues[esFeriadoField.id] = isHoliday;
        console.log(`Campo es_feriado actualizado: ${isHoliday} (fecha: ${currentMonthDay})`);
        console.log('Resultado final isHoliday:', isHoliday);
        console.log('Campo encontrado:', esFeriadoField.field_name);
      } else {
        console.log('Campo es_feriado no encontrado en dynamicFields');
        console.log('Intentando buscar variaciones del nombre...');
      }

    } catch (error) {
      console.error('Error al calcular es_feriado:', error);
    }
  }

  private calculateEsFinDeSemana(currentDate: Date) {
    const dayOfWeek = currentDate.getUTCDay(); // 0 = domingo, 6 = sábado
    const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;

    // Buscar el campo es_fin_de_semana y actualizar su valor
    const esFinDeSemanaField = this.dynamicFields.find(field =>
      field.name === 'Es fin de semana'
    );

    if (esFinDeSemanaField) {
      this.fieldValues[esFinDeSemanaField.id] = isWeekend;
      console.log(`Campo es_fin_de_semana actualizado: ${isWeekend} (día: ${dayOfWeek})`);
    }
  }

  private calculateEsDeNoche(currentTime: number) {
    try {
      // Buscar los campos de horario nocturno
      const inicioHorarioField = this.dynamicFields.find(field =>
        field.name === 'Inicio horario de noche'
      );

      const finHorarioField = this.dynamicFields.find(field =>
        field.name === 'Fin horario de noche'
      );

      if (!inicioHorarioField || !finHorarioField) {
        console.log('Campos de horario nocturno no encontrados');
        return;
      }

      // Obtener valores de los campos (pueden venir del backend o ser valores por defecto)
      const inicioHorario = this.fieldValues[inicioHorarioField.id] || inicioHorarioField.defaultValue || '22:00';
      const finHorario = this.fieldValues[finHorarioField.id] || finHorarioField.defaultValue || '06:00';

      console.log(`Horarios nocturnos configurados: ${inicioHorario} - ${finHorario}`);

      // Convertir horarios a minutos desde medianoche
      const inicioTime = this.timeToMinutes(inicioHorario);
      const finTime = this.timeToMinutes(finHorario);

      let isNightTime = false;

      if (inicioTime <= finTime) {
        // Horario normal (ej: 22:00 - 06:00 del día siguiente)
        isNightTime = currentTime >= inicioTime && currentTime < finTime;
      } else {
        // Horario que cruza medianoche (ej: 22:00 - 06:00)
        isNightTime = currentTime >= inicioTime || currentTime < finTime;
      }

      // Buscar el campo es_de_noche y actualizar su valor
      const esDeNocheField = this.dynamicFields.find(field =>
        field.name === 'Es de noche'
      );

      if (esDeNocheField) {
        this.fieldValues[esDeNocheField.id] = isNightTime;
        console.log(`Campo es_de_noche actualizado: ${isNightTime} (hora actual: ${currentTime} minutos, rango: ${inicioTime}-${finTime})`);
      }

    } catch (error) {
      console.error('Error al calcular es_de_noche:', error);
    }
  }

  private timeToMinutes(timeString: string): number {
    try {
      const [hours, minutes] = timeString.split(':').map(Number);
      return hours * 60 + minutes;
    } catch (error) {
      console.error('Error al convertir tiempo:', timeString, error);
      return 0;
    }
  }

  private calculateEsDangerZone() {
    const esDangerZoneField = this.dynamicFields.find(field =>
      field.name === 'Es zona de riesgo'
    );
    if (esDangerZoneField) {
      this.fieldValues[esDangerZoneField.id] = this.providerSelectedIsDangerZone;
    }
  }

  /**
   * Dibuja la ruta entre el sitio del proveedor y la ubicación del caso.
   * Usa DirectionsService/DirectionsRenderer si está disponible, si falla dibuja una polyline y calcula distancia haversine.
   */
  private async drawProviderToCaseRoute(provider: any) {
    try {
      // Limpiar ruta anterior
      this.clearRoute();

      if (!provider || !provider.provider_site || !this.caseLocation) {
        console.warn('No hay datos de provider o caseLocation para dibujar ruta');
        return;
      }

      const fromLat = Number(provider.provider_site.latitude);
      const fromLng = Number(provider.provider_site.longitude);
      const toLat = Number(this.caseLocation.latitude);
      const toLng = Number(this.caseLocation.longitude);

      if (
        isNaN(fromLat) ||
        isNaN(fromLng) ||
        isNaN(toLat) ||
        isNaN(toLng)
      ) {
        console.warn('Coordenadas inválidas para ruta', { fromLat, fromLng, toLat, toLng });
        return;
      }

      if (!this.providersMap || typeof google === 'undefined' || !google.maps) {
        console.warn('Mapa o Google Maps no disponible, calculando distancia haversine y dibujando polyline simple');
        const km = this.haversineDistance(fromLat, fromLng, toLat, toLng);
        this.currentRoutePolyline = new google.maps.Polyline({
          path: [{ lat: fromLat, lng: fromLng }, { lat: toLat, lng: toLng }],
          strokeColor: '#1976D2',
          strokeOpacity: 0.8,
          strokeWeight: 4,
          map: this.providersMap
        });
        this.currentInfoWindow = new google.maps.InfoWindow({
          content: `Distancia aproximada: ${this.formatDistanceDuration(km, null)}`
        });
        this.currentInfoWindow.setPosition({ lat: (fromLat + toLat) / 2, lng: (fromLng + toLng) / 2 });
        this.currentInfoWindow.open(this.providersMap);
        return;
      }

      const directionsService = new google.maps.DirectionsService();
      const directionsRenderer = new google.maps.DirectionsRenderer({
        suppressMarkers: false,
        polylineOptions: { strokeColor: '#1976D2', strokeWeight: 5 }
      });
      directionsRenderer.setMap(this.providersMap);
      this.currentDirectionsRenderer = directionsRenderer;

      const request: any = {
        origin: { lat: fromLat, lng: fromLng },
        destination: { lat: toLat, lng: toLng },
        travelMode: google.maps.TravelMode.DRIVING,
        unitSystem: google.maps.UnitSystem.METRIC,
      };

      directionsService.route(request, (result: any, status: any) => {
        if (status === 'OK' && result && result.routes && result.routes.length > 0) {
          directionsRenderer.setDirections(result);

          try {
            const leg = result.routes[0].legs[0];
            const distanceMeters = leg.distance ? leg.distance.value : null;
            const durationSec = leg.duration ? leg.duration.value : null;
            const km = distanceMeters != null ? (distanceMeters / 1000) : this.haversineDistance(fromLat, fromLng, toLat, toLng);

            // Crear InfoWindow con distancia/duración
            const content = `<div><b>Distancia:</b> ${this.formatDistanceDuration(km, durationSec)}</div>`;
            this.currentInfoWindow = new google.maps.InfoWindow({ content });

            // Posicionar InfoWindow en el punto medio de la ruta
            let pos = null;
            try {
              const steps = leg.steps || [];
              if (steps.length > 0) {
                const midStep = steps[Math.floor(steps.length / 2)];
                pos = midStep.end_location || midStep.start_location;
              }
            } catch (e) {
              pos = leg.end_location;
            }

            if (!pos) pos = new google.maps.LatLng((fromLat + toLat) / 2, (fromLng + toLng) / 2);
            this.currentInfoWindow.setPosition(pos);
            this.currentInfoWindow.open(this.providersMap);

            // Ajustar bounds para ver la ruta
            try {
              const bounds = new google.maps.LatLngBounds();
              result.routes[0].overview_path.forEach((p: any) => bounds.extend(p));
              this.providersMap.fitBounds(bounds);
            } catch (e) { /* ignore */ }

          } catch (e) {
            console.error('Error procesando resultado de directions:', e);
          }

        } else {
          console.warn('DirectionsService fallo con status', status, 'usando fallback polyline');
          // Fallback: dibujar polyline y calcular distancia haversine
          const km = this.haversineDistance(fromLat, fromLng, toLat, toLng);
          this.currentRoutePolyline = new google.maps.Polyline({
            path: [{ lat: fromLat, lng: fromLng }, { lat: toLat, lng: toLng }],
            strokeColor: '#1976D2',
            strokeOpacity: 0.8,
            strokeWeight: 4,
            map: this.providersMap
          });
          this.currentInfoWindow = new google.maps.InfoWindow({
            content: `Distancia aproximada: ${this.formatDistanceDuration(km, null)}`
          });
          this.currentInfoWindow.setPosition({ lat: (fromLat + toLat) / 2, lng: (fromLng + toLng) / 2 });
          this.currentInfoWindow.open(this.providersMap);
        }
      });

    } catch (error) {
      console.error('Error en drawProviderToCaseRoute:', error);
    }
  }

  private clearRoute() {
    try {
      if (this.currentDirectionsRenderer) {
        try { this.currentDirectionsRenderer.setMap(null); } catch (e) { }
        this.currentDirectionsRenderer = null;
      }
      if (this.currentRoutePolyline) {
        try { this.currentRoutePolyline.setMap(null); } catch (e) { }
        this.currentRoutePolyline = null;
      }
      if (this.currentInfoWindow) {
        try { this.currentInfoWindow.close(); } catch (e) { }
        this.currentInfoWindow = null;
      }
    } catch (error) {
      console.error('Error clearing route:', error);
    }
  }

  /**
   * Calcula la distancia en km entre dos puntos usando la fórmula haversine
   */
  private haversineDistance(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const R = 6371; // km
    const toRad = (v: number) => (v * Math.PI) / 180;
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  private formatDistanceDuration(km: number, durationSec: number | null): string {
    const kmStr = `${km != null ? km.toFixed(2) : 'N/A'} km`;
    if (durationSec != null) {
      const mins = Math.round(durationSec / 60);
      return `${kmStr} • ${mins} min`;
    }
    return `${kmStr}`;
  }

  getDefaultValue(field: any): any {
    if (field.defaultValue !== undefined) {
      return field.defaultValue;
    }

    switch (field.type) {
      case 'text':
      case 'email':
      case 'textarea':
        return '';
      case 'number':
        return 0;
      case 'boolean':
        return false;
      case 'combo':
        return field.options && field.options.length > 0 ? field.options[0] : '';
      case 'date':
        return new Date().toISOString().split('T')[0];
      default:
        return '';
    }
  }

  selectFormula(formula: any) {
    this.selectedFormula = formula;
    this.formulaResult = null;
    this.formulaError = '';

    // No calcular automáticamente, esperar a que el usuario haga clic en "Calcular"
  }

  async calculateFormula() {
    if (!this.selectedFormula) return;

    this.formulaLoading = true;
    this.formulaError = '';

    try {
      // Crear contexto con los valores de los campos dinámicos
      const fieldValues: any = {};
      Object.keys(this.fieldValues).forEach(fieldId => {
        const field = this.dynamicFields.find(f => f.id === fieldId);
        if (field) {
          // Normalizar el nombre del campo como lo hace el editor de fórmulas
          const normalizedName = this.normalizeFieldName(field.name);
          fieldValues[normalizedName] = this.fieldValues[fieldId];

          // También agregar el nombre original por compatibilidad
          fieldValues[field.name] = this.fieldValues[fieldId];
        }
      });

      console.log('Valores de campos para cálculo:', fieldValues);
      console.log('ID de fórmula:', this.selectedFormula.id);

      // Usar el nuevo endpoint del backend para calcular
      const result = await this.formulaService.calculateFormula(parseInt(this.selectedFormula.id), fieldValues);

      if (result.success) {
        this.formulaResult = {
          total: result.result,
          equation: result.equation,
          expression: result.expression,
          formula_name: result.formula_name,
          formula_expression: result.formula_expression,
          web_service_log_id: result.web_service_log_id
        };
        console.log('Resultado del cálculo:', this.formulaResult);
      } else {
        this.formulaError = result.error || 'Error al calcular la fórmula';
        console.error('Error en cálculo:', result.error);
      }

    } catch (error) {
      console.error('Error al calcular fórmula:', error);
      this.formulaError = `Error al calcular la fórmula: ${error instanceof Error ? error.message : 'Error desconocido'}`;
    } finally {
      this.formulaLoading = false;
    }
  }

  async onFieldValueChange(fieldId: string, event: any) {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    this.fieldValues[fieldId] = value;

    // Guardar valor en el backend si tenemos provider_formula_coverage_id
    if (this.provider_formula_coverage_id && this.service_id) {
      try {
        const field = this.dynamicFields.find(f => f.id === fieldId);
        if (field) {
          console.log('Guardando valor de campo en backend:', field.field_name, value);
          await this.dynamicFieldsService.saveFieldValues(this.service_id, this.provider_formula_coverage_id, {
            [field.field_name]: value
          });
        }
      } catch (error) {
        console.error('Error al guardar valor de campo en backend:', error);
        // No mostramos error al usuario, solo lo logueamos
      }
    }

    // Limpiar resultado anterior cuando se cambia un valor
    if (this.selectedFormula) {
      this.formulaResult = null;
      this.formulaError = '';
    }
  }

  getFieldTypeLabel(fieldType: string): string {
    const typeLabels: { [key: string]: string } = {
      'text': 'Texto',
      'number': 'Número',
      'boolean': 'Booleano',
      'combo': 'Lista desplegable',
      'date': 'Fecha',
      'email': 'Email',
      'textarea': 'Área de texto'
    };
    return typeLabels[fieldType] || fieldType;
  }

  normalizeFieldName(fieldName: string): string {
    if (!fieldName || typeof fieldName !== 'string') {
      return '';
    }
    return fieldName.toLowerCase()
      .replace(/\s+/g, '_')
      .replace(/[^a-z0-9_]/g, '');
  }

  useFormula() {
    if (this.selectedFormula && this.formulaResult) {
      // Actualizar el comentario con la información de la fórmula
      this.updateCommentWithFormula();

      // Cerrar el modal
      this.closeFormulaModal();
    }
  }

  setQuotationComment() {
    if (this.selectedFormula && this.formulaResult) {
      // Actualizar el comentario con la información de la fórmula
      this.updateCommentWithFormula();

      // Obtener información del provider y coverage
      let providerInfo = '';
      let coverageInfo = '';

      if (this.editprovider && this.editprovider.provider) {
        providerInfo = `Proveedor: ${this.editprovider.provider.name} (ID: ${this.editprovider.provider.id})`;
        if (this.editprovider.provider_site) {
          providerInfo += `\nSitio: ${this.editprovider.provider_site.name} (ID: ${this.editprovider.provider_site.id})`;
        }
      }

      if (this.editprovider && this.editprovider.coverage) {
        coverageInfo = `Cobertura: ${this.editprovider.coverage.name} (ID: ${this.editprovider.coverage.id})`;
      }

      // Emitir evento para crear comentario de cotización
      this.quotationComment.emit({
        formula: this.selectedFormula,
        result: this.formulaResult,
        comment: this.comment,
        additionalExpenses: this.additionalExpenses,
        additionalExpensesComment: this.additionalExpensesComment,
        providerInfo: providerInfo,
        coverageInfo: coverageInfo,
        provider: this.editprovider?.provider,
        providerSite: this.editprovider?.provider_site,
        coverage: this.editprovider?.coverage
      });

      // Cerrar el modal
      this.closeFormulaModal();
    }
  }

  updateCommentWithFormula() {
    if (this.formulaResult) {
      let commentText = `Fórmula aplicada: ${this.selectedFormula.name} (Bitacora ID: ${this.formulaResult.web_service_log_id})\n`;
      commentText += `Resultado: ${this.formulaResult.total}\n`;

      if (this.additionalExpenses > 0) {
        commentText += `Gastos adicionales: ${this.additionalExpenses}\n`;
        if (this.additionalExpensesComment) {
          commentText += `Comentario gastos: ${this.additionalExpensesComment}\n`;
        }
        commentText += `Total final: ${this.formulaResult.total + this.additionalExpenses}`;
      }

      this.comment = commentText;
    }
  }

  private applyMapBounds() {
    if (!this.providersMap || !this.mapOverlays || this.mapOverlays.length === 0) {
      return;
    }

    setTimeout(() => {
      const bounds = new google.maps.LatLngBounds();

      // Agregar todos los marcadores a los bounds
      this.mapOverlays.forEach((marker) => {
        if (marker && marker.getPosition) {
          bounds.extend(marker.getPosition());
        }
      });

      // Aplicar los bounds al mapa con un pequeño delay para asegurar que se renderice correctamente
      setTimeout(() => {
        if (this.providersMap && bounds && !bounds.isEmpty()) {
          this.providersMap.fitBounds(bounds);

          // Opcional: establecer un zoom máximo para evitar que se acerque demasiado
          const maxZoom = 15;
          const currentZoom = this.providersMap.getZoom();
          if (currentZoom && currentZoom > maxZoom) {
            this.providersMap.setZoom(maxZoom);
          }
        }
      }, 500);
    }, 100);
  }

}